export default "__VITE_ASSET__3214f400__"